import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SharedUtilsDatesService {
  //Day + Month
  getDayMonth(language: string, date: Date): string | null {
    if (date != null) {
      const formatter = new Intl.DateTimeFormat(language, { month: 'short', day: 'numeric' });
      return formatter.format(new Date(date));
    } else return null;
  }

  // Week Days
  getWeekDayName(language: string, date: string): string {
    const formatter = new Intl.DateTimeFormat(language, { weekday: 'long' });
    return formatter.format(new Date(date));
  }

  // Months
  getMonthName(language: string, date): string {
    const formatter = new Intl.DateTimeFormat(language, { month: 'long' });
    return formatter.format(new Date(date));
  }

  // Get the monday
  getMonday(date): Date {
    date = new Date(date);
    const day = date.getDay(),
      diff = date.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    return new Date(date.setDate(diff));
  }

  toDateString(number): string {
    return new Date(number).toISOString();
  }

  parseToDate(date: string): Date {
    return this.convertUTCDateToLocalDate(new Date(date));
  }

  private convertUTCDateToLocalDate(date: Date): Date {
    const newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
    const offset = date.getTimezoneOffset() / 60;
    const hours = date.getHours();
    newDate.setHours(hours - offset);
    return newDate;
  }
}
